export function buildInitials(name: string): string {
  const parts: string[] = name
    .trim()
    .split(/\s+/)
    .filter((part: string): boolean => part.length > 0);
  if (parts.length === 0) return '';
  const first: string = parts[0]?.[0] ?? '';
  const last: string = parts.length > 1 ? (parts[parts.length - 1]?.[0] ?? '') : '';
  return (first + last).toLocaleUpperCase('nl');
}
